import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class Rouge extends Fragment {
    summarize() {
        return new FragmentSummary("rouge");
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }
}
